import React from "react";
type SVGAnchorProps = { className?: string };
const SVGAnchor: React.FC<SVGAnchorProps> = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 20 20"
		width="18"
		height="18"
		fill="none"
		className={props.className}
	>
		<path
			d="M11 5.83a3.001 3.001 0 1 0-2 0V7H6v2h3v8.917a6 6 0 0 1-4.985-5.488l.278.278a1 1 0 0 0 1.414-1.414l-2-2a1 1 0 0 0-1.414 0l-2 2a1 1 0 1 0 1.414 1.414l.303-.303a8 8 0 0 0 15.98 0l.303.303a1 1 0 0 0 1.414-1.414l-2-2a1 1 0 0 0-1.414 0l-2 2a1 1 0 0 0 1.414 1.414l.278-.278A6 6 0 0 1 11 17.917V9h3V7h-3zM11 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
			fill="#B7AEAE"
		/>
	</svg>
);

export default SVGAnchor;